var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoorClosed = function SvgDoorClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M12.6 3.15c.247 0 .45.202.45.45v11.25h-8.1V3.6c0-.248.202-.45.45-.45zm1.8 11.7V3.6c0-.993-.807-1.8-1.8-1.8H5.4c-.993 0-1.8.807-1.8 1.8v11.25H1.575c-.374 0-.675.3-.675.675 0 .374.3.675.675.675h14.85a.673.673 0 0 0 .675-.675.673.673 0 0 0-.675-.675zM11.25 8.1a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8"
  })));
};
export default SvgDoorClosed;